import {ChangeDetectionStrategy, Component, inject, Input, OnInit} from '@angular/core';
import {FormGroup, ReactiveFormsModule} from "@angular/forms";

import {isDeprecatedGeneralOpenAiModel, Models} from "../../../../models/models.model";
import {ClientService} from "../../../../services/auth/client.service";
import {MaterialModule} from "../../../../material.module";
import {ToastService} from "../../../../services/layout/toast.service";


@Component({
  selector: 'app-task-general-settings',
  templateUrl: './task-general-settings.component.html',
  styleUrls: ['./task-general-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MaterialModule, ReactiveFormsModule]
})
export class TasksGeneralSettingsComponent implements OnInit {
    clientService = inject(ClientService);
    private snackBar = inject(ToastService);

  @Input() settingsForm!: FormGroup;

  ngOnInit(): void {
    if (!this.settingsForm) {
      throw new Error('settingsForm Input is required for AssistantGeneralSettingsComponent');
    }
  }

  get modelOptions(): readonly string[] {
    return this.settingsForm.get('responseType')?.value === 'audio'
      ? Models.AudioOpenAIModels
      : Models.AvailableOpenAIModels;
  }

  get legacyModel(): string | null {
    const model = this.settingsForm.get('model')?.value;
    return isDeprecatedGeneralOpenAiModel(model) ? model : null;
  }
}
